// PRD-798: https://confluence.rakuten-it.com/confluence/spaces/TDDI/pages/6517452912/PRD-798
// currencies that share the "$" domestic sign and need global notation to disambiguate (e.g. "US$", "CA$")
// and also PHP
export const alwaysGlobalCurrencies = ['USD', 'CAD', 'AUD', 'NZD', 'SGD', 'HKD', 'TWD', 'PHP'] as const;
